<div id="tipsAndTricksContainer" *ngIf="links.length > 0">
    <strong class="title">Tips & Tricks</strong>
    <div class="links-container">
        <p *ngFor="let link of links" class="link">{{ link }}</p>
    </div>
</div>
